import AppLayout from "../../../../shared/components/AppLayout";
import BackendUnavailablePage from "../../../../shared/components/BackendUnavailablePage";
import LoadingPage from "../../../../shared/components/LoadingPage";
import { siteTexts } from "../../../../shared/i18n/siteTexts";
import { useSiteContent } from "../../../home/shared/hooks/useSiteContent";
import "../../../../shared/components/ContentCard.css";

export default function ShopPage() {
  const { content, loading, backendUnavailable, refresh } = useSiteContent();

  if (loading) {
    return <LoadingPage label={siteTexts.shop.loadingProducts} />;
  }
  if (backendUnavailable) {
    return <BackendUnavailablePage onRetry={refresh} />;
  }

  return (
    <AppLayout title={siteTexts.shop.title} subtitle={siteTexts.shop.subtitle}>
      <div className="card-grid">
        {content.products.map((item, index) => (
          <a key={`${item.title}-${index}`} className="card" href={`#/loja/${index}`}>
            <div
              className="card-media"
              style={
                item.imageUrl ? { backgroundImage: `url(${item.imageUrl})` } : undefined
              }
            />
            <div className="card-body">
              <span className="card-tag">{item.price || siteTexts.shop.priceFallback}</span>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </a>
        ))}
      </div>
    </AppLayout>
  );
}
